module.exports = __webpack_public_path__ + "media/halloween_tipping_tier_1-415c443620282c71df71d9fbdb752671.mp3";